import type { UISortOption } from 'src/components/types/UISortOption';
import type { SortOption } from 'src/redux/productsQuery/types/SortOption';

export const adaptSortOptionsToUISortOptions = (sortOptions: SortOption[]): UISortOption[] => {
  return sortOptions.map((option) => ({
    active: option.active,
    title: option.title,
    value: `${option.key}${option.descending ? '-desc' : '-asc'}`,
  }));
};
